import { useTranslation } from 'react-i18next';

import FormStepWrapper from 'components/form/FormStepWrapper';
import TextInputField from 'components/inputs/TextInputField';
import { useBecomeFundraiser } from 'features/my-profile/become-fundraiser/context/BecomeFundraiserProvider';
import { MAX_BANK_ACCOUNT_NUMBER_LENGTH } from 'features/my-profile/become-fundraiser/context/becomeFundraiserUtils';
import { useAccountNumberHelpPopup } from 'features/my-profile/become-fundraiser/form/components/account-number/useAccountNumberHelpPopup';
import HelpButton from 'features/my-profile/become-fundraiser/form/components/HelpButton';
import SkipButton from 'features/my-profile/become-fundraiser/form/components/SkipButton';

const VerifyAccountNumber = () => {
  const { t } = useTranslation('myProfile');
  const { formData, errors, setFieldValue } = useBecomeFundraiser();
  const { showAccountNumberHelpPopup } = useAccountNumberHelpPopup();
  const isValid = !errors.accountNumber && !errors.accountNumberConfirmation;

  return (
    <FormStepWrapper
      header={t('become-fundraiser.verify-account-number.header')}
      description={t('become-fundraiser.verify-account-number.description')}
      isValid={isValid}>
      <TextInputField
        value={formData.accountNumber || ''}
        onChange={value => setFieldValue('accountNumber', value)}
        placeholder={t('become-fundraiser.verify-account-number.account-number-placeholder')}
        errorMessage={errors.accountNumber}
        maxLength={MAX_BANK_ACCOUNT_NUMBER_LENGTH}
      />
      <TextInputField
        value={formData.accountNumberConfirmation || ''}
        onChange={value => setFieldValue('accountNumberConfirmation', value)}
        placeholder={t('become-fundraiser.verify-account-number.confirm-account-number-placeholder')}
        errorMessage={errors.accountNumberConfirmation}
        successMessage={
          isValid && !!formData.accountNumber ? t('become-fundraiser.verify-account-number.numbers-match') : ''
        }
        maxLength={MAX_BANK_ACCOUNT_NUMBER_LENGTH}
      />
      <HelpButton onClick={showAccountNumberHelpPopup} />
      <SkipButton />
    </FormStepWrapper>
  );
};

export default VerifyAccountNumber;
